export default "__VITE_ASSET__CF4U3bMq__"